import { IconButton } from '@coolblue-development/becky';
import SendIcon from '../../../../../assets/send.svg';
import { useChatContext } from '../../../../../contexts/ChatContext';
import { fetchContact } from '../../../../../utils/fetchContact';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { getChatSession } from '../../../../../utils/getChatSession';
import { $convertToMarkdownString, TRANSFORMERS } from '@lexical/markdown';
import { $getRoot } from 'lexical';

const SendButton = (): JSX.Element => {
  const { selectedChat } = useChatContext();
  const [editor] = useLexicalComposerContext();

  const sendMessage = async (): Promise<void> => {
    if (!selectedChat) return;

    const contact = fetchContact(selectedChat);
    if (!contact) return;

    const chatSession = await getChatSession(contact);
    if (!chatSession) return;

    editor.read(() => {
      const message = $convertToMarkdownString(TRANSFORMERS);
      void chatSession.sendMessage({
        contentType: 'text/markdown',
        message: message
      });
    });

    editor.update(() => $getRoot().clear());
  };

  return (
    <IconButton type="submit" data-testid="send-button" size="small" onClick={sendMessage}>
      <SendIcon />
    </IconButton>
  );
};

export default SendButton;
